import styled from '@emotion/styled'
import { StepsScrollProgress } from './ScrollOverMedia'
import { StepTextBoxes } from './foregrounds/StepTextBoxes'
import { useEffect, useMemo, useRef } from 'react'
import {
  StepScrollProgress,
  useScrollPercentage,
} from '../../util/scrollPercentage'
import { ScrollOverMediaDocument } from '../../../types.generated'
import { Covers } from './foregrounds/Covers'

const ForegroundsContainer = styled.div<{
  stepsCount: number
}>`
  position: relative;
  pointer-events: none;
  ${({ stepsCount }) => {
    return `
      z-index: ${stepsCount + 1};
    `
  }}
`

export interface ScrollOverMediaForegroundsProps {
  doc: ScrollOverMediaDocument
  setActiveStep: (i: number) => void
  setStepsScrollProgress: React.Dispatch<
    React.SetStateAction<StepsScrollProgress>
  >
}

export default function ScrollOverMediaForegrounds(
  props: ScrollOverMediaForegroundsProps
) {
  const textBoxesContainerRef = useRef<HTMLDivElement>(null)

  const updateScrollProgressForAllSteps = (scrollPercentage: number): void => {
    props.setStepsScrollProgress(
      StepScrollProgress.setScrollProgressForAllSteps(scrollPercentage)
    )
  }

  const updateScrollProgressForSingleStep = (
    stepIndex: number,
    progress: number
  ) => {
    props.setStepsScrollProgress((prevState) =>
      StepScrollProgress.setScrollProgressForStep(
        prevState,
        stepIndex,
        progress
      )
    )
  }

  const scrollPercentage = useScrollPercentage(
    textBoxesContainerRef,
    props.doc.data.combine_slices,
  )
  useEffect(() => {
    if (props.doc.data.combine_slices) {
      updateScrollProgressForAllSteps(scrollPercentage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollPercentage, props.doc.data.combine_slices])

  const coverMemo = useMemo(() => {
    return <Covers covers={props.doc.data.covers} />
  }, [props.doc.data])

  const stepForegrounds = props.doc.data.body.map((step, stepIndex) => {
    return (
      <StepTextBoxes
        key={stepIndex}
        step={step}
        stepIndex={stepIndex}
        setActiveStep={props.setActiveStep}
        // only provide property if not in parallax mode
        {...(!props.doc.data.combine_slices && {
          setStepScrollProgress: (progress) =>
            updateScrollProgressForSingleStep(stepIndex, progress),
        })}
      />
    )
  })

  return (
    <>
      <ForegroundsContainer stepsCount={props.doc.data.body.length}>
        {coverMemo}
        <div ref={textBoxesContainerRef}>{stepForegrounds}</div>
      </ForegroundsContainer>
    </>
  )
}
